(function (){
    'use strict';
    angular.module('app').controller('RefferedDetailsController', RefferedDetailsController);

    RefferedDetailsController.$inject=[
        'AffiliateService',
        '$routeParams',
        'AffiliateTransactionClientsTableService',
        '$scope',
        '$location',
        '$window'
    ];

    function RefferedDetailsController(
        AffiliateService,
        $routeParams,
        AffiliateTransactionClientsTableService,
        $scope,
        $location,
        $window
    ){
        const vm = this;
        vm.id = $routeParams.id;
        vm.goBack = function(){
           $window.history.back();
        }

        init();
        function init(){
            getReferredDetails();
            $scope.transactionTable = new AffiliateTransactionClientsTableService().tableData;
        }

        function getReferredDetails(){
            $scope.isFetching = true;
            $scope.hideBtnSave = true;
            AffiliateService.getReferredDetails(vm.id,
                res=>{
                    vm.marketingCompany = res;
                    vm.marketingCompany.name = res.companyName;
                    vm.location = res.location;
                    $scope.isFetching = false;
                },
                err=>{
                    console.log(err)
                    $scope.isFetching = false;
            })
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/RefferedDetailsController.js